export default __webpack_public_path__ + "static/media/logo512.54fac9ed.png";